import { datadogRum } from '@datadog/browser-rum';

import { isDataDogRUMEnabled } from '../Datadog';
export interface Error {
  name: string;
  message: string;
  stack?: string;
}
export const formatError = (error: Error | any): Error => {
  if (error instanceof Error) {
    return error;
  }

  let message;
  if (!error) {
    message = 'Undefined error';
  } else if (error.message) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else {
    message = JSON.stringify(error);
  }
  const err = new Error(message);
  err.name = error?.name ?? 'Error';
  err.stack = error?.stack ?? undefined;

  return err;
};

export interface Logger {
  logInfo: (message: string, context?: Record<string, unknown>) => void;
  logWarn: (
    message: string,
    context?: Record<string, unknown>,
    error?: any | Error,
  ) => void;
  logError: (error: Error | any, context?: Record<string, unknown>) => void;
}

const defaultLogger = (): Logger => ({
  // eslint-disable-next-line no-console
  logInfo: console.info,
  // eslint-disable-next-line no-console
  logWarn: console.info,
  // eslint-disable-next-line no-console
  logError: console.error,
});

const datadogLogger = (): Logger =>
  Object.freeze({
    logInfo: (message: string, context?: Record<string, unknown>) =>
      datadogRum.addAction(message, {
        ...context,
      }),

    logWarn: (
      message: string,
      context?: Record<string, unknown>,
      error?: any | Error,
    ) =>
      datadogRum.addAction(message, {
        ...context,
        error,
      }),

    logError: (error: Error | any, context?: Record<string, unknown>) => {
      const formattedError: Error = formatError(error);
      datadogRum.addError(formattedError, context);
    },
  });

export const getLogger = (): Logger => {
  if (isDataDogRUMEnabled()) {
    return datadogLogger();
  }
  return defaultLogger();
};
